import React from 'react'

const CustomButtonOval = ({
    textLoad,
    loading,
    onClick,
    className,
    children,
    isDisabled,
    ...props
}) => {

    const buttonClassName = `
    flex items-center justify-center
    px-4 py-1.5
    rounded-full
    text-sm font-medium
    transition-all duration-150
    border
    cursor-pointer
    active:scale-[0.97]

    ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}
    ${className}
  `

    return (
        <>
            {loading ? (
                <button
                    onClick={onClick}
                    className="
            flex items-center justify-center
            px-4 py-1.5
            rounded-full
            border border-cs-border
            bg-cs-bg-alt
            text-cs-muted
            mr-3 mb-2
            cursor-not-allowed
          "
                    disabled
                    {...props}
                >
                    <svg
                        className="animate-spin h-4 w-4 mr-2"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                        />
                        <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                        />
                    </svg>
                    <span>{textLoad}...</span>
                </button>
            ) : (
                <button
                    onClick={onClick}
                    className={buttonClassName}
                    disabled={isDisabled}
                    {...props}
                >
                    {children}
                </button>
            )}
        </>
    )
}

export default CustomButtonOval
